// extracted by mini-css-extract-plugin
export default {"select_page_container":"SelectPage_select_page_container__vnAVF"};